<template>
	<!-- 厂商应急保电详情 -->
	<div class="detail">
		<div class="order-status">
			当前状态：
<!--			{{ statusName }}-->

            {{orderInfo.orderSatus == 0 ? '未确认提交': orderInfo.orderSatus == 1 ? '待厂商确认' : orderInfo.orderSatus == 2 ? '待平台签约'
					: orderInfo.orderSatus == 3 ? '待客户支付租金' : orderInfo.orderSatus == 4 ? '待厂商确认收款并发货'
							: orderInfo.orderSatus == 6 ? '待客户收货'
									: orderInfo.orderSatus == 7 ? '待厂商确认用电完成' : orderInfo.orderSatus == 11 ? '待客户确认用电完成'
											: orderInfo.orderSatus == 18 ? '待平台出具结算单' : orderInfo.orderSatus == 28 ? '待厂商结算'
													: orderInfo.orderSatus == 29 ? '待客户收款': orderInfo.orderSatus == 8 ? '已完成'
															: orderInfo.orderSatus == 9 ? '已评价': orderInfo.orderSatus == 60 ? '待厂商确认续费'
																	: orderInfo.orderSatus == 70 ? '中止订单':'其他'
				}}{{(orderInfo.orderSatus==8||orderInfo.orderSatus==29||orderInfo.orderSatus==9)&&orderInfo.serviceFeeStatus==1?"(待收取服务费)":""}}
			{{orderInfo.orderSatus==7&&orderInfo.status!=60?"(可续费)":''}}

<!--			<span v-if="(orderInfo.orderSatus==8||orderInfo.orderSatus==29||orderInfo.orderSatus==9)&&orderInfo.serviceFeeStatus==1">(待收取服务费)</span>-->

			<div class="">
				<el-button type="primary" size="medium" @click="compHandle()" v-if="status == 5&&orderInfo.status!==60">确认发货</el-button>
				<el-button type="warning" size="medium" plain @click="contactService">联系客服</el-button>
			</div>
		</div>
		<div class="case" style="padding-bottom: 20px;" v-if="orderInfo.equipmentList"
			v-for="(item, index) in orderInfo.equipmentList" :key="index">
			<div class="block">
				<div class="img"><img :src="imgUrl + item.pictureUrl" alt="" /></div>
				<div class="commodity">
					<div class="name">{{ item.title }}</div>
					<div class="price">
						价格：
						<span>¥{{ item.emergencyPrice }}</span>
					</div>
					<div class="hint">
						*价格说明：
						<br />
						在勘查现场后，相关费用可能发生变化。
					</div>
				</div>
				<div class="device">
					<div class="title">
						<div class="padding"></div>
						设备信息
					</div>
					<ul>
						<li>
							<div class="key">提供人姓名</div>
							<div class="value">{{ item.companyName }}</div>
						</li>
						<li>
							<div class="key">设备类型</div>
							<div class="value">{{ item.typeName }}</div>
						</li>
						<li>
							<div class="key">设备容量</div>
							<div class="value">{{ item.volume }}</div>
						</li>
						<li>
							<div class="key">设备地点</div>
							<div class="value">
								{{ item.uprovinceName + item.ucityName + item.ucountyName + item.uaddress }}
							</div>
						</li>
						<li>
							<div class="key">输出电压</div>
							<div class="value">{{ item.voltage }}</div>
						</li>
					</ul>
				</div>
			</div>
			<div v-if="orderInfo.serviceFeeRefund == 2"
				style="background-color: #c5c5c5;margin-top: 20px;padding: 20px;">
				<span style="font-size: 14px;">油费：公开油费单价 <a style="color:red">￥{{ item.oilCost }}/小时</a></span>
				<div style="font-size: 14px;">
					单独收费，不计入设备租赁费用中，用户预付每天10小时油费，多退少补</div>
			</div>
			<el-button type="info" size="medium" @click="changeBaodianD(item.id)"
				style="display: flex;justify-content: end;margin-top: 20px;"
				v-if="orderInfo.orderSatus == 1 && orderInfo.serviceFeeRefund == 2">确定设备
			</el-button>
		</div>
		<div class="userinfo">
			<div class="title">用户信息</div>
			<div class="user">
				<div class="name">{{ user.username }}</div>
				<ul>
					<li>
						<div class="key">工程名称：</div>
						<div class="value">{{ orderInfo.projectname }}</div>
					</li>
					<li>
						<div class="key">地址：</div>
						<div class="value">{{ orderInfo.userAddress }}</div>
					</li>
					<li>
						<div class="key">服务天数：</div>
						<div class="value">{{ user.limit }}</div>
					</li>
					<li>
						<div class="key">开始时间：</div>
						<div class="value">{{ orderInfo.startTime |formatDate }}</div>
					</li>
					<li>
						<div class="key">结束时间：</div>
						<div class="value">{{ orderInfo.entTime |formatDate }}</div>
					</li>
<!--					<li>-->
<!--						<div class="key">平台签约时间：</div>-->
<!--						<div class="value">{{ orderInfo.qrhtTime }}</div>-->
<!--					</li>-->
				</ul>
			</div>
			<!-- <div class="renew">
				续费更新
				<li>
					<div class="key">租赁期限：</div>
					<div class="value">{{ renew.limit }}</div>
				</li>
				<li>
					<div class="key">开始时间：</div>
					<div class="value">{{ renew.start }}</div>
				</li>
				<li>
					<div class="key">结束时间：</div>
					<div class="value">{{ renew.end }}</div>
				</li>
			</div> -->
		</div>
		<!-- 订单信息 -->
		<div class="card order-card" v-if="status > 0">
			<div class="card-tit">订单信息</div>
			<el-button class="btn detailBtn" plain @click="viewAccount">查看往来账目</el-button>
			<div class="list">
				<div class="item"><span class="item-tit">申请时间：</span>{{ orderInfo.addTime }}</div>
				<div class="item"><span class="item-tit">订单编号：</span>{{ orderInfo.orderNo }}</div>
				<div class="item"><span class="item-tit">平台技术服务费：</span>¥{{ orderInfo.serviceFee }}</div>
				<div class="item"><span class="item-tit">设备租金：</span>¥{{ orderInfo.advance }}</div>
				<div class="item"><span class="item-tit">预付油费：</span>¥{{ orderInfo.advanceFuel }}</div>
				<div class="item"><span class="item-tit">厂商确认时间：</span>{{ orderInfo.pttkkhTime }}</div>



				<template orderInfo.orderSatus!=70>
					<div class="item"><span class="item-tit">平台签约时间：</span>{{ orderInfo.qrhtTime }}</div>
				<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ orderInfo.khzfTime }}</div>
				<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ orderInfo.csqrskTime }}</div>
				<div class="item"><span class="item-tit">发货时间：</span>{{ orderInfo.delivertime }}</div>
				<div class="item"><span class="item-tit">收货时间：</span>{{ orderInfo.taketime }}</div>

				<template v-if="orderInfo.status!=60">
				<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ orderInfo.factoryfinishtime }}</div>
				<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ orderInfo.customfinishtime }}</div>
				<div class="item"><span class="item-tit">出具结算单时间：</span>{{ orderInfo.ptqrzjTime }}</div>
				<div class="item"><span class="item-tit">厂商退还租金及油费时间：</span>{{ orderInfo.settletime }}</div>
				<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ orderInfo.cszffufTime }}</div>
				<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ orderInfo.ptqrsxfTime }}</div>
				<div class="item"><span class="item-tit">用户确认收款租金及油费时间：</span>{{ orderInfo.khqrskTime }}</div>
				</template>
				</template>

				<div class="item"><span class="item-tit" v-if="orderInfo.orderSatus==70">订单中止时间：</span>{{ orderInfo.zzddTime }}</div>





<!--				<div class="item"><span class="item-tit">申请时间：</span>{{ orderInfo.addTime }}</div>-->
<!--				<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ orderInfo.khzfTime }}</div>-->
<!--				<div class="item"><span class="item-tit">平台确认租金及油费时间：</span>{{ orderInfo.ptqrzjTime }}</div>-->
<!--				<div class="item"><span class="item-tit">订单编号：</span>{{ orderInfo.orderNo }}</div>-->
<!--				<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ orderInfo.cszffufTime }}</div>-->
<!--				<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ orderInfo.ptqrsxfTime }}</div>-->
<!--				<div class="item"><span class="item-tit">设备租金：</span>￥{{ orderInfo.advance }}</div>-->
<!--				<div class="item"><span class="item-tit">发货时间：</span>{{ orderInfo.delivertime }}</div>-->
<!--				<div class="item"><span class="item-tit">收货时间：</span>{{ orderInfo.taketime }}</div>-->
<!--				<div class="item"><span class="item-tit">预付油费：</span>￥{{ orderInfo.advanceFuel }}</div>-->
<!--				<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ orderInfo.factoryfinishtime }}</div>-->
<!--				<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ orderInfo.customfinishtime }}</div>-->
<!--				<div class="item"><span class="item-tit">平台技术服务费：</span>￥{{ orderInfo.serviceFee }}</div>-->
<!--				<div class="item"><span class="item-tit">平台结款厂商租金及油费时间：</span>{{ orderInfo.settletime }}</div>-->
<!--				<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ orderInfo.receivetime }}</div>-->

			</div>
		</div>

		<div class="card order-card" v-if="orderInfo.status == 60 || orderInfo.orderSatus == 60">
			<div class="card-tit">续费信息</div>
			<div class="list">

				<div class="item"><span class="item-tit">续费时间：</span>{{ orderInfo.xftime }}</div>
				<div class="item"><span class="item-tit">续费时长：</span>{{ orderInfo.xfday }}</div>
				<div class="item"><span class="item-tit">续费原因：</span>{{ orderInfo.xfyuanyin }}</div>
				<div class="item"><span class="item-tit">续费价格：</span>¥{{ orderInfo.xufeijg }}</div>
				<div class="item"><span class="item-tit">预付油费：</span>¥{{ orderInfo.xfyoufei }}</div>
				<div class="item"><span class="item-tit">平台技术服务费：</span>¥{{ orderInfo.xfptfwfy }}</div>
				<div class="item"><span class="item-tit">续费申请通过时间：</span>{{ orderInfo.csqrtysqTime }}</div>
				<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ orderInfo.xfkhzftime }}</div>
				<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ orderInfo.xfcsqrsktime }}</div>

<!--				<div class="item"><span class="item-tit">发货时间：</span>{{ orderInfo.xffahuotime }}</div>-->
<!--				<div class="item"><span class="item-tit">收货时间：</span>{{ orderInfo.xfshouhuotime }}</div>-->


				<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ orderInfo.xfcsqrwctime }}</div>
				<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ orderInfo.xfkhqrwctime }}</div>
				<div class="item"><span class="item-tit">出具结算单时间：</span>{{ orderInfo.xfptqrzjtime }}</div>
				<div class="item"><span class="item-tit">厂商退还租金及油费时间：</span>{{ orderInfo.xfptjkcstime }}</div>
				<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ orderInfo.xfcszffwftime }}</div>
				<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ orderInfo.xfptqrfwftime }}</div>
				<div class="item"><span class="item-tit">客户确认收款租金及油费时间：</span>{{ orderInfo.xfkhqrsztime }}</div>



<!--				<div class="item"><span class="item-tit">续费时间：</span>{{ orderInfo.xftime }}</div>-->
<!--				<div class="item"><span class="item-tit">续费时长：</span>{{ orderInfo.xfday }}</div>-->
<!--				<div class="item"><span class="item-tit">续费原因：</span>{{ orderInfo.xfyuanyin }}</div>-->
<!--				<div class="item"><span class="item-tit">续费价格：</span>{{ orderInfo.xufeijg }}</div>-->
<!--				<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ orderInfo.xfkhzftime }}</div>-->
<!--				<div class="item"><span class="item-tit">平台确认租金及油费时间：</span>{{ orderInfo.xfptqrzjtime }}</div>-->
<!--				<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ orderInfo.xfcszffwftime }}</div>-->
<!--				<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ orderInfo.xfptqrfwftime }}</div>-->
<!--				<div class="item"><span class="item-tit">发货时间：</span>{{ orderInfo.xffahuotime }}</div>-->
<!--				<div class="item"><span class="item-tit">收货时间：</span>{{ orderInfo.xfshouhuotime }}</div>-->
<!--				<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ orderInfo.xfcsqrwctime }}</div>-->
<!--				<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ orderInfo.xfkhqrwctime }}</div>-->
<!--				<div class="item"><span class="item-tit">预付油费：</span>￥{{ orderInfo.xfyoufei }}元</div>-->
<!--				<div class="item"><span class="item-tit">平台结款厂商租金及油费时间：</span>{{ orderInfo.xfptjkcstime }}</div>-->
<!--				<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ orderInfo.xfcsqrsktime }}</div>-->
<!--				<div class="item"><span class="item-tit">平台技术服务费：</span>￥{{ orderInfo.xufeizk ? orderInfo.xfptfwfy * orderInfo.xufeizk : orderInfo.xfptfwfy }}</div>-->
<!--				<div class="item"><span class="item-tit">客户确认收款租金及油费时间：</span>{{ orderInfo.xfkhqrsztime }}</div>-->

			</div>
		</div>

		<!-- 保电方案 -->
<!--		<div class="card file-card" v-if="orderInfo.bdscheme != null">-->
<!--			<div class="card-tit">保电方案</div>-->
<!--			<div class="file-box" style="margin-bottom: 20px;">-->
<!--				<img src="./bg.png" class="pdfIcon" alt="" width="50px">-->
<!--			</div>-->
<!--			<div>-->
<!--				<div class="download">-->
<!--					<el-button type="warning" plain size="mini" @click="downloadFile(orderInfo.bdscheme)">下载</el-button>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->

<!--		<div class="file" v-show="status > 2">-->
<!--			<div class="title">附件合同签约</div>-->
<!--			<div class="hint">*已完成签约，可下载签约合同。</div>-->
<!--			<div class="contract">-->
<!--				<div class="cont">-->
<!--					<div class="img"><img src="../../assets/image/PDF.png" alt="" /></div>-->
<!--					<div class="right">-->
<!--						<div class="name">-->
<!--							{{ '应急保电合同' }}-->
<!--							<span>(签约版)</span>-->
<!--						</div>-->
<!--						<div class="time">{{ orderInfo.qrhtTime }}</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="download">-->
<!--					<el-button type="warning" plain size="mini" @click="downloadFile(orderInfo.htUrl)">下载</el-button>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
		<div class="price-baodian" v-if="orderInfo.orderSatus == 1">
			<div class="price">
				<p style="color: black;font-weight: 600;">价格确认</p>
				<div class="item">
					<span>租金/元</span>
					<el-input readonly v-model="reRrice"></el-input>
				</div>
				<div class="item">
					<span>预付油费/元</span>
					<el-input v-model="oliPrice" readonly></el-input>
				</div>
				<div v-if="orderInfo.serviceFeeRefund != 2">
					<span style="margin: 10px 100px;font-size: 14px;">油费：公开油费单价 <a
							style="color:red">￥{{ orderInfo.oilCost }}/小时</a></span>
					<div style="margin-left: 100px;font-size: 14px;">
						单独收费，不计入设备租赁费用中，用户预付每天10小时油费，多退少补</div>
				</div>
			</div>
<!--			<div class="baodian">-->
<!--				<p style="color: black;font-weight: 600;">*保电方案</p>-->
<!--				<div class="upload" style="margin-top: 20px;">-->
<!--					<el-upload :action="$uploadUrl" :before-upload="beforeAvatarUpload" :multiple="false"-->
<!--						list-type="picture-card" :on-success="handleBaodianSuccess" :on-remove="handleRemove"-->
<!--						:show-file-list="false" :accept="$fileExt">-->
<!--						<span v-if="this.baodianList.length == 1" class="avatar">已上传</span>-->
<!--						<i v-else class="el-icon-plus"></i>-->
<!--					</el-upload>-->
<!--				</div>-->
<!--			</div>-->
			<div style="width: 100%;display: flex;justify-content: end;">
				<el-button type="info" size="medium" @click="changeOrder">确认</el-button>
				<el-button type="info" size="medium" @click="deleteOrder">退回</el-button>
				<el-button type="info" v-if="orderInfo.serviceFeeRefund != 2" size="medium" @click="changeBaodian">确定设备
				</el-button>
			</div>
		</div>

		<div class="price-baodian" v-if="orderInfo.orderSatus == 60">
			<div class="price">
				<p style="color: black;font-weight: 600;">续费价格确认</p>
				<div class="item">
					<span>租金/元</span>
					<el-input v-model="orderInfo.xufeijg" readonly></el-input>
				</div>
				<div class="item">
					<span>预付油费/元</span>
					<el-input v-model="orderInfo.xfyoufei" readonly></el-input>
				</div>
				<span style="margin: 10px 100px;font-size: 14px;">油费：公开油费单价 <a
						style="color:red">￥{{ orderInfo.xfyoufei / orderInfo.xfday / 10 }}/小时</a></span>
				<span style="margin-left: 100px;font-size: 14px;">单独收费，不计入设备租赁费用中，用户预付每天10小时油费，多退少补</span>
			</div>
			<div style="width: 100%;display: flex;justify-content: end;">
				<el-button type="info" size="medium" @click="xufeiOk">通过</el-button>
				<el-button type="info" size="medium" @click="xufeiNo">拒绝</el-button>
			</div>
		</div>
		<div class="settle">
			<div class="title" v-if="status == 7">实际用电时间</div>
			<div class="form" v-if="status == 7">
				<ul>
					<li>
						<div class="key">实际租用时间：</div>
						<div class="value">
							<el-input size="medium" type="text" @input="inputChange" v-model="settle.realTime">
								<template slot="append">
									/天
								</template>
							</el-input>
						</div>
					</li>
					<li>
						<div class="key">实际发电时间：</div>
						<div class="value">
							<el-input size="medium" type="text" v-model="settle.realWorkTime">
								<template slot="append">
									/小时
								</template>
							</el-input>
						</div>
					</li>
				</ul>
				<div class="button">
					<!-- <el-button type="primary" size="mini" @click="confirmRealTime">同意</el-button> -->
					<el-button type="info" size="medium" @click="compHandleOver()" v-if="status == 7">用电完成
					</el-button>
				</div>
			</div>
			<div class="list" v-if="status == 11 || status == 18 || status == 28 || status == 8||status == 28||status == 29||status == 8||status == 9">
<!--				<el-card shadow="always" style="height: 200px;margin-top: 20px;"-->
<!--								 v-if="orderInfo.actualUseTime!==0">-->
					<div style="font-size: 20px;font-weight: 600;">实际用电时间</div>
				<el-button v-if="status == 28||status == 29||status == 8||status == 9" style="float: right;" plain @click="viewJsDan">查看结算单</el-button>
				<div style="display: flex;padding: 20px 0;align-items: center;height: 150px;">
					<div class="" style="">
						<span>实际租用时间：{{ orderInfo.actualUseTime }}天</span>
						<span style="margin-left: 20px;">实际发电时间:{{ orderInfo.actualUse }}小时</span>
					</div>
					<div class="" style="display: flex;width: 800px;flex-wrap: wrap;margin-left: 100px;justify-content: space-between;line-height: 30px;">
						<span style="color: red;width: 200px;">客户已付租金：￥{{ orderInfo.xftkcszj }}</span>
						<span style="color: red;width: 200px;">客户实际租金：￥{{ orderInfo.xftkyhzj }}</span>
						<span style="color: red;width: 200px;">退还客户租金：￥{{ orderInfo.xftkzj }}</span>
						<span style="color: red;width: 200px;">结算平台服务费：￥{{ orderInfo.yonghufy }}</span>
						<span style="color: red;width: 200px;">客户已付油费：￥{{ orderInfo.xftkcsyf }}</span>
						<span style="color: red;width: 200px;">客户实际油费：￥{{ orderInfo.xftkyhyf }}</span>
						<span style="color: red;width: 200px;">退还客户油费：￥{{ orderInfo.xftkyf }}</span>
						<span style="color: red;width: 200px;"></span>
					</div>
				</div>
<!--					<div style="display: flex;padding: 20px 0;align-items: center;height: 150px;">-->
<!--						<div class="" style="">-->
<!--							<span>实际租用时间：{{ orderInfo.actualUseTime }}天</span>-->
<!--							<span style="margin-left: 20px;">实际发电时间:{{ orderInfo.actualUse }}小时</span>-->
<!--						</div>-->
<!--						<div class="" style="display: flex;width: 500px;flex-wrap: wrap;margin-left: 100px;justify-content: space-between;line-height: 30px;">-->
<!--							<span style="color: red;width: 200px;">退还客户租金：￥{{ orderInfo.thkhzj }}</span>-->
<!--							&lt;!&ndash;          <span style="color: red;width: 200px;">结算厂家租金：￥{{ form.jscjzj }}</span>&ndash;&gt;-->
<!--							<span style="color: red;width: 200px;">结算平台服务费：￥{{ orderInfo.wfwf }}</span>-->
<!--							<span style="color: red;width: 200px;">退还客户油费：￥{{ orderInfo.thkhyf }}</span>-->
<!--							&lt;!&ndash;          <span style="color: red;width: 200px;">结算厂家油费：￥{{ form.jscjyf }}</span>&ndash;&gt;-->
<!--						</div>-->
<!--					</div>-->
<!--				</el-card>-->
<!--				<ul>-->
<!--					<div class="item">-->
<!--						<li>-->
<!--							<div class="key">实际租用时间：</div>-->
<!--							<div class="value">{{ settle.realTime }}</div>-->
<!--						</li>-->

<!--					</div>-->
<!--					<div class="item">-->
<!--						<li>-->
<!--							<div class="key">实际发电时间：</div>-->
<!--							<div class="value">{{ settle.realWorkTime }}</div>-->
<!--						</li>-->
<!--					</div>-->
<!--					<div class="item red">-->
<!--						<li>-->
<!--							<div class="key">退还客户租金：</div>-->
<!--							<div class="value">{{ settle.refundRent }}</div>-->
<!--						</li>-->
<!--						<li>-->
<!--							<div class="key">退还客户油费：</div>-->
<!--							<div class="value">{{ settle.refundOil }}</div>-->
<!--						</li>-->
<!--					</div>-->
<!--&lt;!&ndash;/*					<span style="color: red;width: 200px;">结算平台服务费：￥{{ orderInfo.wfwf }}</span>*/&ndash;&gt;-->
<!--					<div class="item red">-->
<!--						<li>-->
<!--							<div class="key">结算平台服务费：</div>-->
<!--							<div class="value">{{ orderInfo.wfwf }}</div>-->
<!--						</li>-->
<!--						<li>-->
<!--							<el-button style="float: right;" plain @click="viewJsDan">查看结算单</el-button>-->
<!--						</li>-->
<!--&lt;!&ndash;						<li>&ndash;&gt;-->
<!--&lt;!&ndash;							<div class="key">结算厂家油费：</div>&ndash;&gt;-->
<!--&lt;!&ndash;							<div class="value">{{ settle.settleOil }}</div>&ndash;&gt;-->
<!--&lt;!&ndash;						</li>&ndash;&gt;-->
<!--					</div>-->
<!--				</ul>-->
			</div>

			<div style="background-color: #fff;padding:0 20px 20px;margin-top: 10px;"
					 v-show="status == 28 && orderInfo.equipmentModel != 1">
<!--				<div style="padding: 20px 0;color: red;">*请上传收款凭证</div>-->
<!--				<el-upload style="padding: 0px 0 20px;" :before-upload="beforeAvatarUpload" :action="$uploadUrl"-->
<!--									 list-type="picture-card" :on-success="handleAvatarSuccess29" :multiple="false" :on-remove="handleRemove"-->
<!--									 :accept="$imgExt">-->
<!--					<i class="el-icon-plus"></i>-->
<!--				</el-upload>-->
				<div style="display: flex;justify-content: center;">
					<el-button type="info" size="medium" @click="uploadPaySuccessOrther29">确认结算</el-button>
				</div>
			</div>

			<!-- </div>
		<div class="suspend-agreement">
			<div class="title">终止订单协议</div>
			<div class="contract">
				<div class="cont">
					<div class="img"><img src="../../assets/image/PDF.png" alt="" /></div>
					<div class="right">
						<div class="name">{{ suspendContract.name }}</div>
						<div class="time">{{ suspendContract.time }}</div>
					</div>
				</div>
				<div class="download"><el-button type="warning" plain size="mini" @click="suspendDownload">下载</el-button></div>
				<div class="button">
					<el-button type="primary" size="mini" @click="agreeSuspend">同意</el-button>
					<el-button type="primary" size="mini" plain @click="refuseSuspend">取消</el-button>
				</div>
			</div>-->
		</div>
<!--		<div class="record" v-show="status > 3" style="min-height: 300px;">-->
<!--			<div class="title">支付信息</div>-->
<!--			<div class="hint">*客户确认用电完成后7天结算给厂家。</div>-->
<!--			<ul v-if="orderInfo && orderInfo.voucherList">-->
<!--				<li v-for="(item, index) in orderInfo.voucherList" :key="index">-->
<!--					<div>-->
<!--						<el-image style="height: 150px;width: 150px;border: 1px solid #c5c5c5;"-->
<!--							:src="imgUrl + item.storageAdd" :preview-src-list="[imgUrl + item.storageAdd]"></el-image>-->
<!--					</div>-->
<!--					<div class="name">{{ item.voucherDesc }}</div>-->
<!--					<div class="action">{{ item.voucherSource }}</div>-->
<!--				</li>-->
<!--			</ul>-->
<!--		</div>-->
		<!--确认收款（租金）-->
		<div style="background-color: #fff;padding:0 20px 20px;margin-top: 10px;"
				 v-show="status == 4 ">
			<div style="display: flex;justify-content: center;">
				<el-button type="info" size="medium" @click="uploadPaySuccessOrther4">确认收款</el-button>
			</div>
		</div>

		<div class="card" v-show="status == 9">
			<div class="card-tit borderB">评价列表</div>
			<div class="evaluate-lists">
				<div class="evaluate-box evaluate-item" v-for="item in pinglunList" :key="item.id">
					<div style="display: flex;justify-content: start;align-items: center;">
						<div class="user-name">{{ item.masterName }}</div>
						<span style="margin-left: 40px;">评分</span>
						<div class="score-line">
							<el-rate v-model="item.fractionUser" disabled show-score text-color="#ff9900"
								score-template="">
							</el-rate>
						</div>
						<div class="user-name time" style="margin-left: 20px;">{{ item.updateTime }}</div>
					</div>
					<div class="evaluate" style="margin: 20px 0;">{{ item.proposal }}</div>
					<div class="imgs" v-if="item.proposalUrl">
						<el-image :src="imgUrl + item1" :preview-src-list="[imgUrl + item1]" style="width: 200px;height: 150px;
						margin-right: 20px;" v-for="item1 in item.proposalUrl.split(',')" :key="item1"></el-image>
					</div>
				</div>
			</div>
		</div>



		<div class="card" v-show="orderInfo.estimate">
			<div class="card-tit borderB">回复内容</div>
			<div class="evaluate-lists">
				<div class="evaluate-box evaluate-item">
					<div style="display: flex;justify-content: start;align-items: center;">
						<div class="user-name">{{ orderInfo.companyName }}</div>
						<div class="user-name time" style="margin-left: 20px;">{{ orderInfo.cshfTime }}</div>
					</div>
					<div class="evaluate" style="margin: 20px 0;">{{ orderInfo.estimate }}</div>
					<div class="imgs" v-if="orderInfo.factoryPingJiaImg">
						<el-image :src="imgUrl + item1" :preview-src-list="[imgUrl + item1]" style="width: 150px;height: 150px;
						margin-right: 20px;" v-for="item1 in orderInfo.factoryPingJiaImg.split(',')" :key="item1">
						</el-image>
					</div>
				</div>
			</div>
		</div>
		<!-- 回复评价  -->
		<div style="background-color: #fff;margin-top: 10px;padding: 20px;"
			v-if="orderInfo.orderSatus == 9 && orderInfo.proposal && orderInfo.reply == 1">
			<div>回复评价</div>
			<div style="padding: 20px 0;">
				<el-input style="width: 40%;" type="textarea" resize="none" :rows="7" v-model="pjneirong" />
				<div style="margin: 20px 0px;">
					<el-upload :limit="2" :multiple="false" :before-upload="beforeAvatarUpload"
						:on-remove="handleRemove" :action="$uploadUrl" list-type="picture-card"
						:on-success="handleUploadSuccess" :accept="$imgExt">
						<i class="el-icon-plus"></i>
					</el-upload>
				</div>
				<!-- <div style="margin: 0 20px;line-height: 30px;">
					<div>综合评分</div>
					<el-rate v-model="rate"></el-rate>
				</div> -->
				<div>
					<el-button size="medium" type="info" @click="pingjia">回复评论</el-button>
				</div>
			</div>
		</div>
		<account-dialog ref="accountDialogRef"></account-dialog>
<!--		<js-dan ></js-dan>-->
		<js-dan ref="jsDanRef"></js-dan>
	</div>
</template>

<script>
import AccountDialog from '../../view/orderDetail/accountList.vue'
import {
	equOrderDetail,
	updateOrder,
	addVoucherAllApi,
	delOrder
} from '../../http/factory/add-eme.js';
import serverConfig from "@/http/config";
import JsDan from "@/view/orderDetail/jsDan.vue";
export default {
	name: 'detail',
	components: {
		JsDan,
		AccountDialog
	},
	filters: {
		formatDate(date1) {
			let date = new Date(date1)
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hour = String(date.getHours()).padStart(2, '0');
			const minute = String(date.getMinutes()).padStart(2, '0');

			// 格式化为 'YYYY-MM-DD HH:mm' 的形式
			return `${year}-${month}-${day}`;
		}
	},
	data() {
		return {
      imgUrl:serverConfig.baseURL,
			baodianList: [],
			reRrice: '',
			oilPrice: '',
			uploadUrl: '',
			imageUrl: [],
			status: '已完成',
			commodity: {
				img: require('../../assets/image/img_3.png'),
				name: '',
				price: ''
			},
			device: {
				username: '',
				type: '',
				capacity: '',
				position: '',
				voltage: '',
				stauts: ''
			},
			scheme: {
				description: ''
			},
			user: {
				avatar: require('../../assets/image/avatar.png'),
				username: '',
				address: '',
				limit: '',
				start: '',
				end: ''
			},
			renew: {
				limit: '',
				start: '',
				end: '',
				total: '',
				sum: '',
				discount: '',
				discountNum: 85,
				price_1: '',
				price_2: '',
				renew_price: ''
			},
			contract: {
				name: '',
				time: '',
				filePath: ''
			},
			pinglunList: [],
			order: {
				applyTime: '2022/6/19',
				payTime: '2022/6/19',
				confirmTime: '2022/6/19',
				confirmContract: '2022/6/19',
				payServiceTime: '2022/6/19',
				confirmServiceTime: '2022/6/19',
				series: '0123456789',
				deliverTime: '2022/6/191',
				takeTime: '2022/6/192',
				factoryFinishTime: '2022/6/193',
				customFinishTime: '2022/6/194',
				refundTime: '2022/6/195',
				customConfirmTime: '2022/6/196',
				rent: '20007',
				settleTime: '2022/6/198',
				receiveTime: '2022/6/199',
				prePayOil: '600/260小时0',
				renew: {
					applyTime: '2022/6/19',
					payTime: '2022/6/19',
					confirmTime: '2022/6/19',
					confirmContract: '2022/6/19',
					payServiceTime: '2022/6/19',
					confirmServiceTime: '2022/6/19',
					series: '0123456789',
					deliverTime: '2022/6/19',
					takeTime: '2022/6/19',
					factoryFinishTime: '2022/6/19',
					customFinishTime: '2022/6/19',
					refundTime: '2022/6/19',
					customConfirmTime: '2022/6/19',
					price: '2000',
					settleTime: '2022/6/19',
					receiveTime: '2022/6/19',
					prePayOil: '600/260小时',
					limit: '123天',
					reason: ''
				},
				suspend: {
					applyTime: '2022/6/19',
					reason: '2022/6/19',
					confirmTime: '2022/6/19'
				}
			},
			settle: {
				realTime: '',
				realWorkTime: '',
				refundRent: '100',
				refundOil: '1000',
				settleRent: '10000',
				settleOil: '100000'
			},
			suspendContract: {
				name: '',
				time: '2022/6/19',
				filePath: ''
			},
			record: [],
			payment: {
				alipay: require('../../assets/image/ali.jpg'),
				wechat: require('../../assets/image/wechat.jpg'),
				unipay: require('../../assets/image/qrcode.png')
			},
			statusName: '',
			orderInfo: {},
			accountList: [],
			pjneirong: '',
			rate: 0,
			loading: [],
		};
	},
	methods: {
		viewJsDan() {
			this.$refs.jsDanRef.showDialog(this.orderInfo.jsDanVos)
		},
		beforeAvatarUpload() {
			this.loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
		},
		inputChange() {
			let day = this.orderInfo.advanceDate + (this.orderInfo.xfday == null ? 0 : this.orderInfo.xfday)
			if (this.settle.realTime >= day) {
				console.log(day);
				this.settle.realTime = day;
			}
		},
		xufeiOk() {
			this.$confirm('您确定通过当前订单的续费申请吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.id,
					// xfptqrzjtime: new Date(),
					csqrtysqTime: this.formatTime(),
					status: 60,
					orderSatus: 3
				}).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})


		},
		xufeiNo() {
			this.$confirm('你确定要退回当前订单的续费申请吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.id,
					status: 0,
					orderSatus: 7
				}).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})
		},
		handleUploadSuccess(file) {
			setTimeout(() => {
          this.loading.close();
            this.imageUrl.push(file.fileName)
        }, 1000);

		},
		// 评论图片删除方法
		handleRemove(e) {
			console.log("删除", e.response.fileName);
			console.log("shanchju", this.imageUrl);
			var a = this.imageUrl.indexOf(e.response.fileName)
			if (a > -1) {
				this.imageUrl.splice(a, 1)
				console.log("卡", this.imageUrl);
			}
		},
		// 订单支付信息上传图片删除方法
		// handleRemove(e, fileList) {
		// 	console.log("删除", e.response.fileName);
		// 	console.log("shanchju", this.imageUrl);
		// 	var a = this.imageUrl.indexOf(e.response.fileName)
		// 	if (a > -1) {
		// 		this.imageUrl.splice(a, 1)
		// 		console.log("卡", this.imageUrl);
		// 	}
		// },
		pingjia() {
			if (this.pjneirong == '') {
				this.$message({
					message: '请输入回复内容',
					type: 'warning'
				})
				return
			}
			updateOrder({
				id: this.id,
				estimate: this.pjneirong,
				reply: 2,
				// cshfTime: new Date(),
				cshfTime: this.formatTime(),
				factoryPingJiaImg: this.imageUrl.join(',')
			}).then(res => {
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$router.go(-1)
			})
		},
		viewAccount() {
			this.$refs.accountDialogRef.showDialog(this.accountList)
		},
		deleteOrder() {
			// delOrder({
			// 	id: this.orderInfo.id
			// }).then(res => {
			// 	this.$message({
			// 		message: '退回订单成功！',
			// 		type: 'success',
			// 		duration: 2000
			// 	});
			// 	this.$router.go(-1)
			// })
			this.$confirm('你确定要退回当前订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.orderInfo.id,
					orderSatus: 0
				}).then(res => {
					this.$message({
						message: '退回成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})

		},
		changeBaodian() {
			this.$router.push({
				path: '/factoryUser/changeEme',
				query: {
					equId: this.orderInfo.equipmentId,
					orderId: this.orderInfo.id,
					factoryId: this.orderInfo.businessId,
					type: 1
				}
			})
		},
		changeBaodianD(id) {
			this.$router.push({
				path: '/factoryUser/changeEme',
				query: {
					equId: id,
					orderId: this.orderInfo.id,
					factoryId: this.orderInfo.businessId,
					type: 2
				}
			})
		},
		changeOrder() {
			// if (this.baodianList.length != 1) {
			// 	this.$message({
			// 		message: '请上传保电方案',
			// 		type: 'warning'
			// 	});
			// 	return
			// }
			// console.log(this.baodianList);
			// return

			this.$confirm('你确定要接收当前订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.id,
					orderSatus: 2,
					advance: this.reRrice,
					pttkkhTime:this.formatTime(),
					// bdscheme: this.baodianList.join(',')
				}).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})

		},
		handleAvatarSuccess(file) {
			setTimeout(() => {
          this.loading.close();
           this.imageUrl.push(file.fileName);
        }, 1000);

		},
		handleBaodianSuccess(file) {
			console.log("ssss", file);
			setTimeout(() => {
          this.loading.close();
           this.baodianList = [],
				this.baodianList.push(file.fileName)
        }, 1000);

		},

		// beforeAvatarUpload() { },
		contactService() {
			this.$router.push({
				path: '/service'
			})
		},
		downloadFile(url) {
			if (!url) {
				return this.$message('当前文件暂时不能下载')
			}
			window.open(this.imgUrl + url)
		},
		checkOrder() {
			this.$refs.accountDialogRef.showDialog(this.accountList)
		},
		confirmSuspend() { },
		confirmRenew() { },
		refuseRenew() { },
		suspendDownload() { },
		agreeSuspend() { },
		refuseSuspend() { },
		uploadPaySuccess() {
			// if (this.imageUrl.length <= 0) {
			// 	this.$message({
			// 		message: '请上传凭证',
			// 		type: 'warning'
			// 	});
			// 	return
			// }
			// console.log(this.imageUrl);
			// return
			let arr = []
			for (let item of this.imageUrl) {
				arr.push({
					orderId: this.id,
					type: 0,
					storageAdd: item,
					voucherDesc: this.orderInfo.status == 60 ? '平台（技术）服务费(续)' : '平台（技术）服务费',
					voucherSource: '厂商-支付'
				})
			}
			// addVoucherAllApi({
			// 	voucherList: arr
			// })
			if (this.orderInfo.status == 60) {



				updateOrder({
					id: this.id,
					orderSatus: 34,
					// xfcszffwftime: new Date(),
					xfcszffwftime: this.formatTime(),
				}).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			} else {
				updateOrder({
					id: this.id,
					orderSatus: 34,
					// cszffufTime: new Date(),
					cszffufTime: this.formatTime(),
				}).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			}
		},
		uploadPaySuccessOrther4() {
			let obj = {
				id: this.id,
			}
			if (this.orderInfo.status == 60) {
				obj['status'] = 60
				// xfcsqrsktime
				obj['xfcsqrsktime'] = this.formatTime()
			} else {
				// obj['receivetime'] = new Date()
				// csqrskTime
				obj['csqrskTime'] = this.formatTime()
			}
			if (this.orderInfo.equipmentModel == null || this.orderInfo.equipmentModel == '') {
				obj['equipmentModel'] = 2
			} else {
				obj['equipmentModel'] = 2
				obj['orderSatus'] = 8
			}
			if(this.orderInfo.orderSatus==4){
				obj['orderSatus']=6
				obj['delivertime']=this.formatTime()
			}
			if(this.orderInfo.status==60){
				obj['orderSatus']=7
				obj['ktype']=5
			}
			// console.log(obj)
			// return

			this.$confirm('你确定收到了当前订单的租金和油费吗？确定发货了吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder(obj).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})
		},
		uploadPaySuccessOrther() {
			if (this.imageUrl.length <= 0) {
				this.$message({
					message: '请上传凭证',
					type: 'warning'
				});
				return
			}
			// console.log(this.imageUrl);
			// return
			let arr = []
			for (let item of this.imageUrl) {
				arr.push({
					orderId: this.id,
					type: 0,
					storageAdd: item,
					voucherDesc: this.orderInfo.status == 60 ? '设备费用' : '设备费用',
					voucherSource: '厂商-收款'
				})
			}
			addVoucherAllApi({
				voucherList: arr
			})
			let obj = {
				id: this.id,
			}
			if (this.orderInfo.status == 60) {
				obj['status'] = 60
				obj['xfcsqrsktime'] = this.formatTime()
			} else {
				// obj['receivetime'] = new Date()
				obj['receivetime'] = this.formatTime()
			}
			if (this.orderInfo.equipmentModel == null || this.orderInfo.equipmentModel == '') {
				obj['equipmentModel'] = 2
			} else {
				obj['equipmentModel'] = 2
				obj['orderSatus'] = 8
			}
			// console.log(obj)
			// return
			updateOrder(obj).then(res => {
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				this.$router.go(-1)
			})
		},
		uploadPaySuccessOrther29() {
			let obj = {
				id: this.id,
			}
			if (this.orderInfo.status == 60) {
				obj['status'] = 60
				// xfptjkcstime
				// xfcszffwftime
				obj['xfptjkcstime'] = this.formatTime()
				obj['xfcszffwftime'] = this.formatTime()
			} else {
				// settletime
				// cszffufTime
				// obj['receivetime'] = new Date()
				obj['settletime'] = this.formatTime()
				obj['cszffufTime'] = this.formatTime()
			}
			if (this.orderInfo.equipmentModel == null || this.orderInfo.equipmentModel == '') {
				obj['equipmentModel'] = 2
			} else {
				obj['equipmentModel'] = 2
				obj['orderSatus'] = 29
			}
			 console.log(obj)
			// debugger
			// return


			this.$confirm('您确定当前订单已经退款给客户，并且已经支付服务费了吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder(obj).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})
		},
		afterReceiveUpload() {
			updateOrder({
				id: this.id,
				// ptqrzjTime: new Date(),
				ptqrzjTime: this.formatTime(),
				voucher: {
					storageAdd: this.imageUrl,
					type: 3
				}
			}).then(res => {
				this.$message({
					message: '修改成功',
					type: 'success'
				});
				this.$router.go(-1)
			})
		},
		confirmRealTime() { },
		compHandle() {
			if (this.orderInfo.status == 60) {
				this.$confirm('您确定已经发货了吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.id,
						orderSatus: 6,
						// xffahuotime: new Date(),
						xffahuotime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			} else {
				this.$confirm('您确定发货了吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.id,
						orderSatus: 6,
						// delivertime: new Date(),
						delivertime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			}
		},
		compHandleOver() {

			if (this.orderInfo.status == 60) {
				if (this.settle.realTime == '') {
					this.$message({
						message: '请输入实际租用时间',
						type: 'warning'
					});
					return false;
				}
				if (this.settle.realWorkTime == '') {
					this.$message({
						message: '请输入实际发电时间',
						type: 'warning'
					});
					return false;
				}
				if (this.orderInfo.xfday + this.orderInfo.advanceDate < this.settle.realTime) {
					this.$message({
						message: '输入时长不能大于实际时长',
						type: 'warning'
					});
					return
				}
				this.$confirm('您确定当前订单的设备发电情况是这样的吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.id,
						orderSatus: 11,
						// xfcsqrwctime: new Date(),
						xfcsqrwctime: this.formatTime(),
						actualUseTime: this.settle.realTime,
						actualUse: this.settle.realWorkTime
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			} else {
				if (this.orderInfo.advanceDate + this.orderInfo.xfday < this.settle.realTime) {
					this.$message({
						message: '输入时长不能大于实际时长',
						type: 'warning'
					});
					return
				}
				this.$confirm('您确定当前订单的设备发电情况是这样的吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.id,
						orderSatus: 11,
						// factoryfinishtime: new Date(),
						factoryfinishtime: this.formatTime(),
						actualUseTime: this.settle.realTime,
						actualUse: this.settle.realWorkTime
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			}
		},
		fetchData() {
			equOrderDetail({
				id: this.id
			}).then(res => {
				this.orderInfo = res
				this.orderInfo.equipmentList = JSON.parse(this.orderInfo.equipmentList)
				console.log('equipmentList', this.orderInfo.equipmentList);
				this.settle.refundRent = res.thkhzj;
				this.settle.refundOil = res.thkhyf;
				this.settle.settleOil = res.jscjyf;
				this.settle.settleRent = res.jscjzj;
				this.settle.realTime = res.actualUseTime
				this.settle.realWorkTime = res.actualUse
				this.order.deliverTime = res.delivertime
				this.order.takeTime = res.taketime
				this.order.factoryFinishTime = res.factoryfinishtime
				this.order.customFinishTime = res.customfinishtime
				this.order.refundTime = res.refundtime
				this.order.customConfirmTime = res.customconfirmtime
				this.order.rent = res.advance
				this.order.settleTime = res.settletime
				this.order.receiveTime = res.receivetime
				this.order.prePayOil = res.advanceFuel + "/" + Number(res.advanceDate) * 10 + "小时"

				//回显设备金额和油费
				this.reRrice = res.advance
				this.oliPrice = res.advanceFuel

				this.accountList = res.accountsList

				// if (res.orderSatus == 1) {
				// 	this.statusName = "待确认"
				// }
				// if (res.orderSatus == 2) {
				// 	this.statusName = "待签约"
				// }
				// if (res.orderSatus == 3) {
				// 	this.statusName = "待客户支付租金"
				// }
				// if (res.orderSatus == 4) {
				// 	this.statusName = "待收款（租金）"
				// }
				// if (res.orderSatus == 24) {
				// 	this.statusName = "待支付服务费"
				// }
				// if (res.orderSatus == 34) {
				// 	this.statusName = "已支付（待平台确认服务费）"
				// }
				// if (res.orderSatus == 5) {
				// 	this.statusName = "待发货"
				// }
				// if (res.orderSatus == 6) {
				// 	this.statusName = "待收货"
				// }
				// if (res.orderSatus == 7) {
				// 	this.statusName = "已收货（待确认用电完成）"
				// }
				// if (res.orderSatus == 11) {
				// 	this.statusName = "待客户确认用电完成"
				// }
				// if (res.orderSatus == 18) {
				// 	this.statusName = "待结款"
				// }
				// if (res.orderSatus == 9) {
				// 	this.statusName = "已结算待确认收款"
				// }
				// if (res.orderSatus == 28 && res.equipmentModel != 2) {
				// 	this.statusName = "已结款（待确认收款）"
				// }
				// if (res.orderSatus == 8 || (res.orderSatus == 28 && res.equipmentModel == 2)) {
				// 	this.statusName = "已完成"
				// }
				// if (res.orderSatus == 28 && res.equipmentModel != 1) {
				// 	this.statusName = "退款给客户"
				// }
				// if (res.orderSatus == 9) {
				// 	this.statusName = "已评价"
				// }
				// if (res.orderSatus == 60) {
				// 	this.statusName = "续费申请"
				// }
				this.status = res.orderSatus
				this.commodity.img = this.imgUrl + res.pictureUrl
				this.commodity.name = res.title
				this.commodity.price = res.emergencyPrice + '/天'
				this.device.username = res.bdName
				this.device.type = res.typeName
				this.device.capacity = res.volume
				this.device.position = res.provinceName + res.cityName
				this.device.voltage = res.voltage
				this.device.stauts = res.bdStatus
				this.scheme.description = res.scheme
				this.user.username = res.masterName
				this.user.address = res.uprovinceName + res.ucityName + res.ucountyName + res.uaddress
				this.user.limit = res.advanceDate + '天'
				this.user.start = res.startTime
				this.user.end = res.entTime

				this.order.applyTime = res.addTime
				this.order.payTime = res.khzfTime
				this.order.confirmTime = res.ptqrzjTime
				this.order.confirmContract = res.qrhtTime
				this.order.payServiceTime = res.cszffufTime
				this.order.confirmServiceTime = res.ptqrsxfTime
				this.order.series = res.orderNo
				this.pinglunList = res.emergencyPowerProtectionOrders

			})
		},
	},
	mounted: function () {
		//模板编译/挂载之后
		this.id = this.$route.query.id
		this.fetchData()
	}
};
</script>

<style lang="less" scoped="scoped">
.card {
	background-color: #fff;
	margin-top: 10px;
	padding: 20px 20px;

	.card-tit {
		color: #000;
		margin: 0px 0 20px;
	}

}

// 订单信息
.order-card {
	position: relative;

	.detailBtn {
		position: absolute;
		right: 20px;
		top: 10px;
	}

	.list {
		border-top: 1px solid #E9E9E9;
		border-bottom: unset;
		padding: 20px 0;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
		line-height: 30px;

		.item {
			display: flex;
			width: 33%;
			padding-left: 0;
			box-sizing: border-box;

			&.tit {
				display: block;
			}

			&.line {
				display: block;
			}

			&.price {
				font-size: .12rem;
				color: #A0A0A0;

				.num {
					color: #FF5858;
				}

				.item-tit {
					color: #979797;
				}
			}
		}

		.item-tit {
			color: #8D8D8D;
		}
	}
}

.price-baodian {
	background-color: #fff;
	margin-top: 10px;
	display: flex;
	flex-wrap: wrap;
	padding: 20px 20px;

	.price {
		width: 45%;
		margin-right: 20px;
		line-height: 30px;
		display: flex;
		flex-direction: column;
		color: #53575d;

		.item {
			display: flex;
			margin-top: 10px;

			span {
				width: 100px;
			}

			.el-input {
				width: 300px;
			}
		}
	}

	.baodian {
		flex: 1;
	}
}

.avatar-uploader .el-upload {
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
	border: 1px dashed #d9d9d9;
}

.avatar-uploader-icon:hover {
	border-color: #409eff;
}

.avatar {
	width: 148px;
	height: 148px;
	display: block;
	font-size: 16px;
}

.avatar1 {
	width: 148px;
	height: 148px;
	display: block;
}

.order-status {
	width: 100%;
	height: 60px;
	padding: 0px @vue-spacing-row-lg;
	box-sizing: border-box;
	background: @vue-bg-color;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: orange;
}

.case {
	width: 100%;
	padding: 0px @vue-spacing-row-lg;
	padding-top: 50px;
	box-sizing: border-box;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.block {
		width: 100%;
		display: flex;
		justify-content: space-between;

		.commodity,
		.device {
			width: calc((100% - 220px) / 2);
		}

		.img {
			width: 220px;
			height: 220px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.commodity {
			padding: 0px @vue-spacing-row-base;
			box-sizing: border-box;

			.name {
				width: 100%;
				line-height: 40px;
				font-size: @vue-font-size-sm;
				font-weight: bold;
			}

			.price {
				width: 100%;
				height: 40px;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-sm - 2;

				span {
					color: @vue-text-color-red;
					font-size: @vue-font-size-sm + 2;
					font-weight: bold;
				}
			}

			.hint {
				width: 100%;
				line-height: 30px;
				font-size: @vue-font-size-min;
				color: orange;
			}
		}

		.device {
			border: 1px solid orange;

			.title {
				width: 100%;
				height: 40px;
				background: #fff2ee;
				padding: 0px @vue-spacing-row-base;
				box-sizing: border-box;
				display: flex;
				align-items: center;

				.padding {
					width: 4px;
					height: 20px;
					background: @vue-bg-color-red;
					margin-right: @vue-spacing-row-sm;
				}
			}

			ul {
				width: 100%;
				background: #fffcfe;
				padding: 0px @vue-spacing-row-base;
				box-sizing: border-box;
				display: flex;
				flex-wrap: wrap;

				li {
					width: 50%;
					height: 50px;
					display: flex;

					.key,
					.value {
						height: 100%;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-min;
					}

					.key {
						width: 80px;
						color: @vue-text-color-grey;
					}

					.value {
						width: calc(100% - 80px);
					}
				}
			}
		}
	}

	.scheme-block {
		width: 100%;
		padding-bottom: @vue-spacing-col-lg;

		.scheme-title {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
		}

		.scheme-list {
			width: 100%;
			background: @vue-bg-color-grey;
			display: flex;
			flex-wrap: wrap;
			padding: @vue-spacing-col-base @vue-spacing-row-base;
			box-sizing: border-box;
		}
	}
}

.userinfo {
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		border-bottom: 1px solid @vue-border-color;
	}

	.user {
		width: 100%;
		height: 100px;
		display: flex;
		align-items: center;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		border-bottom: 1px solid @vue-border-color;

		.avatar {
			width: 60px;
			height: 60px;
			border-radius: @vue-border-radius-circle;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.name {
			height: 100%;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm;
			font-weight: bold;
			padding: @vue-spacing-row-base;
			box-sizing: border-box;
		}

		ul {
			height: 100%;
			display: flex;
			align-items: center;

			li {
				padding: 0px @vue-spacing-row-lg;
				box-sizing: border-box;

				.key,
				.value {
					height: 25px;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
				}

				.key {
					color: @vue-text-color-grey;
				}
			}

			li:first-child {
				border-left: 1px solid @vue-border-color;
			}
		}
	}

	.renew {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;

		li {
			height: 100%;
			display: flex;
			margin: 0px @vue-spacing-row-lg;

			.key,
			.value {
				height: 100%;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-min;
			}

			.key {
				width: 80px;
				color: @vue-text-color-grey;
			}

			.value {
				width: calc(100% - 80px);
			}
		}
	}
}

.file,
.suspend-agreement {
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		border-bottom: 1px solid @vue-border-color;
	}

	.hint {
		line-height: 40px;
		font-size: @vue-font-size-min;
		color: @vue-text-color-red;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}

	.contract {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;

		.cont {
			width: 100%;
			height: 80px;
			display: flex;
			align-items: center;

			.img {
				width: 60px;
				height: 60px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.right {
				margin-left: @vue-spacing-row-base;

				.name,
				.time {
					line-height: 30px;
					font-size: @vue-font-size-sm - 2;
				}

				.name {
					span {
						color: orange;
					}
				}

				.time {
					color: @vue-text-color-grey;
				}
			}
		}

		.download {
			width: 100%;
			height: 60px;
			padding-top: 10px;
			box-sizing: border-box;
		}

		.button {
			width: 100%;
			height: 60px;
			padding-top: 10px;
			box-sizing: border-box;
			display: flex;
			justify-content: center;
			align-items: flex-start;

			.el-button {
				width: 120px;
			}
		}
	}
}

.order {
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @vue-border-color;
	}

	.time-list {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;

		li {
			width: 33.3%;
			height: 40px;
			display: flex;

			.key,
			.value {
				height: 100%;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-min;
			}

			.key {
				color: @vue-text-color-grey;
			}
		}
	}

	.renew {
		border-top: 1px solid @vue-border-color;
	}

	.suspend,
	.renew {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		border-top: 1px solid @vue-border-color;

		.caption {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm;
		}

		.renew-list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;

			li {
				width: 33.3%;
			}
		}

		li {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm - 2;

			.key {
				color: @vue-text-color-grey;
			}
		}

		.button {
			width: 100%;
			height: 60px;
			padding-top: 10px;
			box-sizing: border-box;
		}
	}
}

.settle {
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @vue-border-color;
	}

	.form {
		width: 100%;
		padding: 20px 0;
		box-sizing: border-box;

		ul {
			width: 100%;

			padding: @vue-spacing-col-sm @vue-spacing-row-base;
			box-sizing: border-box;
			display: flex;

			li {
				width: 400px;
				height: 40px;
				display: flex;

				.key,
				.value {
					height: 100%;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-min;
				}

				.key {
					color: @vue-text-color-grey;
				}
			}
		}

		.button {
			width: 100%;
			padding: 20px;
			box-sizing: border-box;
		}
	}

	.list {
		width: 100%;
		padding: @vue-spacing-col-lg @vue-spacing-row-lg;
		box-sizing: border-box;

		ul {
			background: @vue-bg-color-grey;
			width: 100%;
			display: flex;
			height: 80px;

			.item {
				width: 25%;
				height: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				padding-left: @vue-spacing-row-lg;
				box-sizing: border-box;

				li {
					width: 100%;
					height: 40px;
					display: flex;

					.key,
					.value {
						height: 100%;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-min;
					}

					.key {
						color: @vue-text-color-grey;
					}
				}
			}

			.item.red {
				color: @vue-text-color-red;

				li {
					.key {
						color: @vue-text-color-red;
					}
				}
			}
		}
	}
}

.renew-confirm {
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @vue-border-color;
	}

	.hint {
		line-height: 40px;
		font-size: @vue-font-size-min;
		color: @vue-text-color-red;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}

	.price {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;

		.block {
			background: @vue-bg-color-grey;
			width: 100%;
			height: 60px;
			display: flex;

			ul {
				width: 800px;
				display: flex;
				align-items: center;

				li {
					width: 33.3%;
					height: 40px;
					display: flex;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;

					.key,
					.value {
						height: 100%;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-min;
					}

					.key {
						color: @vue-text-color-grey;
					}
				}
			}

			.input {
				width: calc(100% - 800px);
				height: 100%;
				display: flex;
				align-items: center;
				font-size: @vue-font-size-min;

				.el-input {
					width: 80px;
				}

				.el-input,
				.el-button {
					margin: 0px @vue-spacing-row-sm;
				}
			}
		}

		.total {
			width: 100%;
			height: 50px;
			line-height: 50px;
			background: @vue-bg-color-grey;
			padding-left: @vue-spacing-row-base;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm - 2;
			border-top: 1px solid @vue-border-color;

			span {
				color: @vue-text-color-red;
				font-size: @vue-font-size-sm + 2;
			}
		}

		.button {
			width: 100%;
			height: 60px;
			padding-top: 10px;
			box-sizing: border-box;
		}
	}
}

.record {
	width: 100%;
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @vue-border-color;
	}

	.hint {
		line-height: 40px;
		font-size: @vue-font-size-min;
		color: @vue-text-color-red;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}

	ul {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;

		li {
			width: 140px;
			margin-right: @vue-spacing-row-lg;
			margin-bottom: @vue-spacing-col-lg;

			.img {
				width: 100%;
				height: 240px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.name,
			.action {
				width: 100%;
				height: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.name {
				font-size: @vue-font-size-sm - 2;
			}

			.action {
				font-size: @vue-font-size-min;
				color: @vue-text-color-grey;
			}
		}
	}
}

.payment {
	width: 100%;
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @vue-border-color;
	}

	.hint {
		line-height: 40px;
		font-size: @vue-font-size-min;
		color: @vue-text-color-red;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}

	ul {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;

		li {
			width: 140px;
			margin-right: @vue-spacing-row-lg;

			.img {
				width: 100%;
				height: 140px;

				a,
				img {
					width: 100%;
					height: 100%;
				}
			}

			.name {
				width: 100%;
				height: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: @vue-font-size-sm - 2;
			}
		}
	}

	.upload {
		width: 100%;

		.upload-area {
			width: 100%;
			padding: 0px @vue-spacing-row-lg;
			box-sizing: border-box;
		}
	}

	.button {
		width: 100%;
		height: 60px;
		padding: 0px @vue-spacing-row-lg;
		padding-top: 10px;
		box-sizing: border-box;
	}
}

.evaluate {
	width: 100%;
	width: 100%;
	background: @vue-bg-color;
	margin-top: @vue-spacing-col-lg;

	.title {
		width: 100%;
		height: 50px;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @vue-border-color;
	}

	.content {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;

		span {
			display: flex;
			justify-content: center;
			line-height: 80px;
			color: @vue-text-color-red;
		}
	}
}
</style>
